import type { ReactElement } from "react"
import BaseContainer from "@gatsby-plugin-generic-page/components/BaseContainer"
import BaseSection from "@gatsby-plugin-generic-page/components/BaseSection"
import Header from "@gatsby-plugin-generic-page/components/Header"
import type { MarketplaceMediaCardsSectionFlatData } from "@gatsby-plugin-generic-page/fragments/marketplaceMediaCardsSection"
import isEmpty from "~/lib/isEmpty"
import MarketplaceCard from "./MarketplaceCard"

export default function MarketplaceMediaCardsSection({
  header,
  cards,
  sectionSettings,
}: MarketplaceMediaCardsSectionFlatData): ReactElement<MarketplaceMediaCardsSectionFlatData> {
  const leftCards = cards.filter((_, index) => index % 2 === 0)
  const rightCards = cards.filter((_, index) => index % 2 !== 0)

  return (
    <BaseSection {...sectionSettings}>
      <BaseContainer {...sectionSettings?.containerSettings}>
        {!isEmpty(header) ? (
          <div className="mb-7">
            <Header {...header} />
          </div>
        ) : null}

        <div className="flex flex-col gap-5 lg:hidden">
          {cards.map((card, index) => (
            <MarketplaceCard key={`${card.title}-${index}`} card={card} />
          ))}
        </div>

        <div className="hidden lg:flex gap-5">
          <div className="flex flex-col gap-5 flex-1">
            {leftCards.map((card, index) => (
              <MarketplaceCard
                key={`left-${index}`}
                card={card}
                isTitleAsHeading={false}
              />
            ))}
          </div>

          <div className="flex flex-col gap-5 flex-1">
            {rightCards.map((card, index) => (
              <MarketplaceCard
                key={`right-${index}`}
                card={card}
                isTitleAsHeading={false}
              />
            ))}
          </div>
        </div>
      </BaseContainer>
    </BaseSection>
  )
}
